define(['require', 'jquery', 'globalVars'], (
    require,
    $,
    { $body, $window }
) => {
    return {
        init() {
            this.initCache();
            if (this.$subscribe.is(':visible')) {
                require(['subscribe'], subscribe => {
                    subscribe.init('content');
                });
            }
            this.initEvents();
        },

        initCache() {
            this.$subscribe = $('#subscribe');
            this.$subscribeForm = $('#subscribeForm');
            this.$submitButton = $('#subscribeSubmit');
        },

        initEvents() {

            this.$subscribe.on(
              'blur',
              '#subscribeEmail',
              this.formValidate.bind(this)
            );

            this.$subscribe.on(
              'change',
              '#subscribeNewsletter',
              this.formValidate.bind(this)
              );

            $body.on(
                'click',
                '.js-open-popup-subscribe',
                this.showSubscribeBlock.bind(this)
            );
        },

        showSubscribeBlock(e) {
            e.preventDefault();

            const $target = $(e.currentTarget);

            if ($target.closest('#stickyHeaderNav').length) {
                $('#menuToggle').click();
            }

            this.$subscribe.show();

            setTimeout(() => {
                $('html, body').animate(
                    {
                        scrollTop: this.$subscribe.offset().top,
                    },
                    2000
                );
            }, 300);

            let source;

            if ($target.closest('#stickyHeader').length) {
                source = 'header';
            } else if ($target.closest('#pageFooter').length) {
                source = 'footer';
            } else {
                source = 'content';
            }

            require(['subscribe'], subscribe => {
                subscribe.init(source);
            });
        },

        formValidate() {
            this.$subscribeForm.valid() ?
              this.$submitButton.removeClass('_disabled'):
              this.$submitButton.addClass('_disabled')
        },
    };
});
